import React from 'react'
import styled from 'styled-components'

import { media, mediaMax } from 'styles/media'

import { Title, EscapeLink, Item, List, Outer } from './shared'

const ListsWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${mediaMax.md`
    ${List} {
      &:not(:first-child) {
        margin-top: 0;
      }
    }
  `}

  ${media.md`
    flex-direction: row;

    ${List} {
      &:not(:first-child) {
        margin-left: 200px;
      }
    }
  `}
`

type State = {
  name: string
  code: string
}

type Country = {
  id: string
  code: string
  name: string
  states: State[]
}

type CountryAndStateLinksProps = {
  countries: Country[]
}

const CountryAndStateLinks = ({ countries }: CountryAndStateLinksProps) => {
  return (
    <Outer>
      <Title>Escape in:</Title>
      <ListsWrapper>
        {countries?.map(({ code: countryCode, name: countryName, states }) => (
          <List columns={1} key={countryCode}>
            <Item>
              <EscapeLink
                to={{
                  pathname: '/listings',
                  search: `?type=accommodation&country=${countryCode}&state=all`,
                  state: {
                    scrollTop: true,
                  },
                }}
              >
                All {countryName}
              </EscapeLink>
            </Item>
            {states?.map(({ name: stateName, code: stateCode }) => {
              return (
                <Item key={stateCode}>
                  <EscapeLink
                    to={{
                      pathname: '/listings',
                      search: `?type=accommodation&country=${countryCode}&state=${stateCode}`,
                      state: {
                        scrollTop: true,
                      },
                    }}
                  >
                    {stateName}
                  </EscapeLink>
                </Item>
              )
            })}
          </List>
        ))}
      </ListsWrapper>
    </Outer>
  )
}

export default CountryAndStateLinks
